import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { MatDialog} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { Dimensions,  ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

import { ProductoModel, ProductoParamModel, ProductosSucursalesModel } from './../../models/producto/producto.model';
import { ProductoService } from '../../services/producto.service';
import { ProductoDialogComponent } from '../producto-dialog/producto-dialog.component';
import { ProductospresentacionDialogComponent } from '../productospresentacion-dialog/productospresentacion-dialog.component';
import { ProductossucursalDialogComponent } from '../productossucursal-dialog/productossucursal-dialog.component';
import { ProductoscategoriasDialogComponent } from '../productoscategorias-dialog/productoscategorias-dialog.component';
import { ProductosingredientesDialogComponent } from '../productosingredientes-dialog/productosingredientes-dialog.component';
import { ProductoImprimirDialogComponent } from '../producto-imprimir-dialog/producto-imprimir-dialog.component';


@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.css']
})

export class ProductoComponent implements OnInit {


  constructor(private catproductos: ProductoService,
              private dialog: MatDialog,
              public paginatorInt: MatPaginatorIntl) { }
  
  imagenPerfilvacia: string;
  paramproductolmodel: ProductoParamModel;
  producto: ProductoModel;
  displayedColumns: string[] = [];
  datasource: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  tabla: any[];

  ngOnInit(): void {

            this.imagenPerfilvacia = './assets/iconouser/pastel1.jpg';
            this.producto = new ProductoModel();
            this.paramproductolmodel = new ProductoParamModel();
            this.paramproductolmodel.idsucursal = sessionStorage.ids;
            this.paramproductolmodel.idpresentacion = 0;
            this.paramproductolmodel.idcategoria = 0;
            this.paramproductolmodel.idproducto = 0;

            this.getGridProducto();

            this.paginatorInt.firstPageLabel = 'Primera página';
            this.paginatorInt.lastPageLabel = 'Última página';
            this.paginatorInt.itemsPerPageLabel = 'Registro por página';
            this.paginatorInt.nextPageLabel     = 'Siguiente página';
            this.paginatorInt.previousPageLabel = 'Anterior página';

  }

  reloadgrid() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    this.getGridProducto();
    Swal.close();
  }

  acceso(  idmodulo: number, idsubmodulo: number, row) {
   this.openDialogProducto(row);
  }

  eliminarProducto(row) {

    row.operacion = 3;
    row.idusuario = Number(sessionStorage.idu);
    row.imagenb64 = '';
    row.imagen_minb64 = '';
    console.log(row);

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn ',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: true,
      confirmButtonColor: '#391410',
      cancelButtonColor: '#d01d17',
      confirmButtonText: 'Aceptar'
    } );

    swalWithBootstrapButtons.fire({
      title: '¿Dar de baja el producto?',
      text: 'Confirme por favor',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {

          this.catproductos.abcProducto(row).subscribe( (resp: any[]) => {
          Swal.close();

          // if (this.productomodel.operacion === 1) { // nuevo registro
          //   this.productomodel.idproducto = resp['idrespuesta'] !== -1 || resp['idrespuesta'] !== -2 ? resp['idrespuesta'] : 0 ;
          // }
          if (resp) {
          //  console.log(this.productomodel);
            if (resp['idrespuesta'] > 0) {
              Swal.fire({
                icon: 'success',
                text: resp['respuesta']
              });
              } else {
              Swal.fire({
                icon: 'error',
                text: resp['respuesta']
              });
              }
          }
          }, (err) => {
            switch (err.status) {
            case 0:
                Swal.fire({
                  icon: 'warning',
                  text: 'No hay conexión con el servidor'
                });
                break;
              case 409:
                Swal.fire({
                icon: 'error',
                text: 'Error ' + err.status + ' en el guardado del catálogo de productos'
                });
                break;
              case 500:
                  Swal.fire({
                    icon: 'error',
                    text: 'Error ' + err.status + ' en el guardado del catálogo de productos'
                  });
                  break;
            }
          });

          swalWithBootstrapButtons.fire(
            'Atención!',
            'El producto ha sido dado de baja.',
            'success'
          );

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          'Cancelar',
          'La operación de baja ha sido cancelada',
          'error'
        );
      }
    });

  }

  getGridProducto() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    if (Number(sessionStorage.getItem('idr')) === 1) {
      this.displayedColumns = ['orden', 'nombre', 'estadisponible', 'enhome', 'aplicaiva', 'ieps', 'usaleyenda', 'tieneextras', 'tienecereza', 'tieneotrosextras', 'descripcion', 'url_imagen_miniatura', 'actions'];
    } else {
      this.displayedColumns = ['orden', 'nombre', 'estadisponible', 'enhome', 'aplicaiva', 'ieps', 'usaleyenda', 'tieneextras', 'tienecereza', 'tieneotrosextras', 'descripcion', 'url_imagen_miniatura', 'actions'];
    }
    this.catproductos.getCatProductoGrid(this.paramproductolmodel).subscribe( (resp: any[]) => {
          Swal.close();
          this.dataSource = new MatTableDataSource<any>(resp);
          this.tabla = resp;
          this.dataSource.paginator = this.paginator;
    }, (err) => {
      Swal.close();
      switch (err.status) {
      case 0:
          Swal.fire({
            icon: 'warning',
            text: 'No hay conexión con el servidor'
          });
          break;
       case 409:
         Swal.fire({
          icon: 'error',
          text: 'Error ' + err.status + ' para el grid de productos en el servidor'
         });
         break;
        case 500:
            Swal.fire({
              icon: 'error',
              text: 'Error ' + err.status + ' para el grid de productos en el servidor'
            });
            break;

      }
    });
  }

  openDialogProducto(rows): void {
    if ( rows === undefined ) {
      const dialogRef = this.dialog.open( ProductoDialogComponent , {

        data: {titulo: 'Agregar el producto',
          row: '',
        },
        disableClose: true,
        height: String(screen.height * 0.90),
        width: String(screen.width * 0.80),
        panelClass: 'full-screen-modal'
      });
      dialogRef.afterClosed().subscribe(result => {
       this.getGridProducto();
      });
    } else {
      const dialogRef = this.dialog.open( ProductoDialogComponent , {
        data: {titulo: 'Actualizar el producto',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.80),
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getGridProducto();
      });
    }
  }

  openDialogProductosPresentacion(rows): void {
   
      const dialogRef = this.dialog.open( ProductospresentacionDialogComponent , {
        data: {titulo: 'Agregar presentación',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.80),
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getGridProducto();
      });
    
  }

  openDialogProductosSucursal(rows): void {
    const dialogRef = this.dialog.open( ProductossucursalDialogComponent , {
      data: {titulo: 'Agregar sucursal',
      row: rows
    },
    disableClose: true,
    height: String(screen.height * 1),
    width: String(screen.width * 1),
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getGridProducto();
    });

  }

  openDialogProductosCategoria(rows): void {
    const dialogRef = this.dialog.open( ProductoscategoriasDialogComponent , {
      data: {titulo: 'Asignar categoría',
      row: rows
    },
    disableClose: true,
    height: String(screen.height * 0.90),
    width: String(screen.width * 0.80),
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getGridProducto();
    });
  }

  openDialogProductosIngrediente(rows): void {
    const dialogRef = this.dialog.open( ProductosingredientesDialogComponent , {
      data: {titulo: 'ingredientes (Arma tu pastel)',
      row: rows
    },
    disableClose: true,
    height: String(screen.height * 0.90),
    width: String(screen.width * 0.80),
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getGridProducto();
    });
  }

  openDialogImprimir(rows): void {
    // if ( rows === undefined ) {
      const dialogRef = this.dialog.open( ProductoImprimirDialogComponent , {
        data: {titulo: 'Vista previa',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.90),
      });
      dialogRef.afterClosed().subscribe(result => {
       // this.getGridSucursal();
      });
    // }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tablaFilter(filterValue.trim().toLowerCase());
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  tablaFilter(cadena: string) {

    // llenar la tabla para el reporte
    // const cadena = filterValue.trim().toLowerCase();
    const tablatemp = [];
    for (let i=0; i < this.tabla.length; i++) {
      if (this.tabla[i].orden.toString().trim().toLowerCase().indexOf(cadena) > -1 ||
          this.tabla[i].nombre.trim().toLowerCase().indexOf(cadena) > -1 ||
          this.tabla[i].descripcion.trim().toLowerCase().indexOf(cadena) > -1
         ) {
        tablatemp.push(this.tabla[i]);
      }
    }
    this.tabla = [];
    this.tabla = tablatemp;
    console.log(tablatemp);
  }


}
